/**
 * UX Audit Phase 2 (Task #2050) — Public & Auth route slice.
 *
 * Extracted from App.tsx to keep the root entry-point under 200 lines.
 * Covers: auth pages, public verifier, share landing, public discover,
 * trust center public, status, onboarding wizard & portal, terms, privacy.
 */
import { lazy } from "react";
import { Route, Redirect } from "wouter";
import Login from "@/pages/auth/Login";

const Landing = lazy(() => import("@/pages/dashboard/Landing"));
const TermsOfService = lazy(() => import("@/pages/public/TermsOfService"));
const PrivacyPolicy = lazy(() => import("@/pages/public/PrivacyPolicy"));
const VerificationLanding = lazy(() => import("@/pages/public/VerificationLanding"));
const ShareLanding = lazy(() => import("@/pages/public/ShareLanding"));
const SharePrivacyNotice = lazy(() => import("@/pages/public/SharePrivacyNotice"));
const PrivacyRequest = lazy(() => import("@/pages/public/PrivacyRequest"));
const PrivacyVerify = lazy(() => import("@/pages/public/PrivacyVerify"));
const ShareLeadForm = lazy(() => import("@/pages/public/ShareLeadForm"));
const ShareProposalViewer = lazy(() => import("@/pages/public/ShareProposalViewer"));
const PublicDiscover = lazy(() => import("@/pages/public/Discover"));
const TrustCenterPublic = lazy(() => import("@/pages/public/TrustCenterPublic"));
const PublicStatus = lazy(() => import("@/pages/public/Status"));
const MFA = lazy(() => import("@/pages/auth/MFA"));
const MfaTotp = lazy(() => import("@/pages/auth/MfaTotp"));
const SessionExpired = lazy(() => import("@/pages/auth/SessionExpired"));
const Unauthorized = lazy(() => import("@/pages/auth/Unauthorized"));
const ForgotPassword = lazy(() => import("@/pages/auth/ForgotPassword"));
const ResetPassword = lazy(() => import("@/pages/auth/ResetPassword"));
const AcceptInvitation = lazy(() => import("@/pages/auth/AcceptInvitation"));
const SsoLogin = lazy(() => import("@/pages/auth/SsoLogin"));
const TenantSelect = lazy(() => import("@/pages/auth/TenantSelect"));
const AcceptIssuerInvitation = lazy(() => import("@/pages/credentials/AcceptIssuerInvitation"));
const OnboardingWizard = lazy(() => import("@/pages/access/OnboardingWizard"));
const OnboardingPortal = lazy(() => import("@/pages/onboarding/OnboardingPortal"));
const VerificationPage = lazy(() => import("@/pages/verify/VerificationPage"));
const PtwVerify = lazy(() => import("@/pages/ptw/PtwVerify"));
const LinkExpired = lazy(() => import("@/pages/public/LinkExpired"));
const ForceChangePassword = lazy(() => import("@/pages/auth/ForceChangePassword"));

export function publicRoutes() {
  return (
    <>
      <Route path="/" component={Landing} />
      <Route path="/auth/login" component={Login} />
      <Route path="/auth/sso" component={SsoLogin} />
      <Route path="/auth/mfa" component={MFA} />
      <Route path="/auth/mfa-totp" component={MfaTotp} />
      <Route path="/auth/expired" component={SessionExpired} />
      <Route path="/auth/unauthorized" component={Unauthorized} />
      <Route path="/auth/forgot-password" component={ForgotPassword} />
      <Route path="/auth/reset-password/:token" component={ResetPassword} />
      <Route path="/invite/:token" component={AcceptInvitation} />
      <Route path="/issuer-invite/:token" component={AcceptIssuerInvitation} />
      <Route path="/select-tenant" component={TenantSelect} />
      <Route path="/onboarding/welcome" component={OnboardingWizard} />
      <Route path="/onboarding/portal/:token" component={OnboardingPortal} />
      <Route path="/terms" component={TermsOfService} />
      <Route path="/privacy" component={PrivacyPolicy} />
      <Route path="/status" component={PublicStatus} />
      <Route path="/v/:token" component={VerificationPage} />
      <Route path="/verify/ptw/:token" component={PtwVerify} />
      <Route path="/s/:token" component={ShareLanding} />
      <Route path="/s/:token/contact" component={ShareLeadForm} />
      <Route path="/s/:token/privacy" component={SharePrivacyNotice} />
      <Route path="/p/:token" component={ShareProposalViewer} />
      <Route path="/s/:token/privacy/request" component={PrivacyRequest} />
      <Route path="/privacy/request" component={PrivacyRequest} />
      <Route path="/privacy/verify/:token" component={PrivacyVerify} />
      <Route path="/discover" component={PublicDiscover} />
      <Route path="/t/:partnerSlug" component={TrustCenterPublic} />
      <Route path="/link-expired" component={LinkExpired} />
      <Route path="/auth/force-change-password" component={ForceChangePassword} />
    </>
  );
}
